<template lang="pug">
a(v-if="isExternalLink" v-bind="$attrs" :href="to" target="_blank")
	slot
router-link(v-else v-bind="$props" custom v-slot="{ isActive, href, navigate }")
	a(v-bind="$attrs" :href="href" @click="navigate" :class="isActive ? activeClass : inactiveClass")
		slot
		//-span {{$props}}
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
	name: 'AppLink',
	inheritAttrs: false,
	props: {
		...RouterLink.props,
		activeClass: {
			type: String,
			default: 'router-link-active',
		},
		inactiveClass: {
			type: String,
			default: '',
		},
	},
	computed: {
		isActiveAncestor() {
			console.log(this.$router.currentRoute);
			console.log(this.$props.to);
			console.log('-----------------');
			return true;
		},
		isExternalLink() {
			return typeof this.to === 'string' && this.to.startsWith('http');
		},
	},
}
</script>
